// extracted by mini-css-extract-plugin
export var container = "_e3-0";
export var infoIcon = "_e3-2";
export var internalLabel = "_e3-3";
export var titleRowCol = "_e3-1";